import Card from 'ui/components/atoms/Card';
import Tag from 'ui/components/atoms/Tag';
import { convertStringToSlug, dateFormatter, triggerNativeMessage } from '../../../helpers/utils';
import useIsNativeView from '../../../hooks/useIsNativeView';
import { useSearchParams } from 'next/navigation';
import { Article, Province } from '../../../interface';
import { IBreadcrumbs } from '../Breadcrumbs';
import { FEATURE, PAGE_NAME_BRANCH_SALES } from '../../../constants/emarsys/branch-sales';
import eventClickDetailBranchSales from '../../../helpers/emarsys/branch-sales/eventClickDetailBranchSales';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';

interface ICurrentInformationProps {
  items: Article[];
  breadcrumbItems?: IBreadcrumbs[];
  branchProvince?: Province;
  pageTitle?: string;
  city?: string;
  cityCodeProps?: string;
  feature?: string;
}

const CurrentInformation = ({
  items,
  breadcrumbItems = [],
  branchProvince,
  pageTitle = '',
  city = '',
  cityCodeProps = '',
  feature = '',
}: ICurrentInformationProps) => {
  const isNativeView = useIsNativeView();
  const searchParams = useSearchParams();
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth) || {
    userData: null,
  };

  const handleGoToNewsTipsBranchDetail = (e, message, data) => {
    if (isNativeView) {
      e.preventDefault();
    }

    if (feature === FEATURE.BRANCH_LISTING_PAGE) {
      eventClickDetailBranchSales({
        dispatch,
        customerNo: userData?.customerNo,
        breadcrumbItems: breadcrumbItems,
        pageName: PAGE_NAME_BRANCH_SALES.LIST_DEALER_TOYOTA,
        pageTitle: pageTitle,
        sectionName: 'update bengkel',
        buttonName: 'pilih update bengkel',
        newParams: {
          province: branchProvince?.name ?? '',
          province_code: branchProvince?.isocode ?? '',
          update_bengkel_name: data?.titlePage ?? '',
          city: city,
          city_code: cityCodeProps,
          ...(breadcrumbItems?.[2]?.name
            ? {
                menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase(),
              }
            : {}),
        },
      });
    }

    const cityCode = searchParams.get('area');
    const branchCode = data?.branch?.branchLandingPage?.seoSlug || null;
    const slugUniqueSplitted = data?.slugUnique.split('/');
    const slug = slugUniqueSplitted[slugUniqueSplitted.length - 1] || null;

    const params = {
      citySlug: cityCode,
      branchSlug: branchCode,
      slug: slug,
    };

    triggerNativeMessage(message, params);
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 md:gap-6">
      {items.map((item) => {
        return (
          <a
            id={`card-current-info-${item.titlePage?.toLowerCase()?.replace(/ /g, '-')}`}
            href={item.slug}
            key={item.slugUnique}
            onClick={(e) => handleGoToNewsTipsBranchDetail(e, 'goToNewsTipsBranchDetail', item)}
          >
            <Card key={item.id} className={`border border-reliableBlack10 h-full`}>
              {/* Tag */}
              <div className={`${!item.tag && 'pb-8'}`}>
                {item.tag && (
                  <Tag
                    className="rounded-br"
                    severity={`${item.tag === 'Trending' ? 'info' : 'warn'}`}
                  >
                    {item.tag}
                  </Tag>
                )}
              </div>
              <div className="pt-2 px-3 pb-5">
                <img
                  className="w-full aspect-video object-cover mb-4"
                  src={item.heroImageLink}
                  alt={item.altImage}
                />
                <p className="text-xs font-medium text-reliableBlack mb-6 h-12 line-clamp-3 lg:text-lg lg:font-semibold lg:mb-3 lg:h-fit">
                  {item.titlePage}
                </p>
                <p className="text-xs font-normal text-reliableBlack70 lg:text-sm">
                  <span>{item.publishedDate ? dateFormatter(item.publishedDate) : '-'}</span>
                </p>
              </div>
            </Card>
          </a>
        );
      })}
      {items?.length === 0 && (
        <div className="mt-4 lg:mt-0">
          <p className="text-sm lg:text-base">Informasi Terkini tidak tersedia.</p>
        </div>
      )}
    </div>
  );
};
export default CurrentInformation;
